export const surroundings = {
  initialize: function () {
    SwiperComponents.initSlider('.js-swiper-surroundings', {
      slidesPerView: 'auto',
      slideVisibleClass: 'swiper-slide-visible',
      watchSlidesProgress: true,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 15,
          slidesPerGroup: 2
        }
      }
    });

    $('.js-showSurroundings').attr('href', `${GLOBAL_SCRIPTS.URL_CURRENT}/${PRODUCT_SCRIPTS.WORDING_PRODUCT.tab_cpe_surroundings.toLowerCase().replace(/\s+/g, '-')}`);
  }
};